import { RouterProvider } from "react-router-dom";
import { router } from "@/app/router";
import { SessionProvider } from "@/lib/session/SessionContext";
import { DialogProvider } from "@/lib/dialogs/DialogProvider";
import { InstallPrompt } from "@/components/InstallPrompt";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <SessionProvider>
      <DialogProvider>
        <RouterProvider router={router} />
        <InstallPrompt />
        <Toaster />
      </DialogProvider>
    </SessionProvider>
  );
}

export default App;
